import React from 'react';
import { createContext, useContext, useState } from 'react';
import { configs } from '../../assets/Config';
import { acknowledgeManualPaymentByOrder, approveHighValueOrder, buyOrderComment, completeDematTransferByOrder, completeRefundHighValueOrder, deleteOrder, downloadHDFCSheet, downloadInvoice, downloadDealNote, downloadSocialMediaImage, downloadSPDSheet, generateCashfreePaymentLink, getAllCompanies, getAllMandates, getCCAvenueHistory, getCompanySlabs, getOrderDetail, getOrderListByType, manualOrderPunchCustomerId, refundHighValueOrder, rejectHighValueOrder, restoreOrder, saveUTRByOrderId, updatePayPendingStatusByOrder, getQueryFormData, getPrevSocialMediaImageData, getUntaggedPaymentByType } from '../apis/shareManagement/BuyOrdersApi';
import { useLogin } from './AdminLoginContext';

// create buyOrder management context
export const buyOrderContext = createContext();


export function BuyOrderProvider({ children }) {

    const { token, setLoginError, logout } = useLogin()

    const [orderId, setOrderId] = useState("")
    const [utrDetailModal, setUtrDetailModal] = useState(false)
    const [dematTransferModal, setDematTransferModal] = useState(false)
    const [payPendStatusModal, setpayPendStatusModal] = useState(false)
    const [utrBreakupModal, setUtrBreakupModal] = useState(false)
    const [manualPayAckModal, setManualPayAckModal] = useState(false)
    const [hpApproveModal, setHPApproveModal] = useState(false)
    const [hpRejectModal, setHPRejectModal] = useState(false)
    const [hpRefundModal, setHPRefundModal] = useState(false)
    const [hpCompleteRefundModal, setHPCompleteRefundModal] = useState(false)
    const [hpApproveQuantity, setHPApproveQuantity] = useState("")
    const [hpApprovePrice, setHPApprovePrice] = useState("")
    const [hpApproveInstrument, setHPApproveInstrument] = useState("")
    const [orderDetail, setOrderDetail] = useState("")
    const [update, setUpdate] = useState(false)
    const [commentModal, setCommentModal] = useState(false)
    const [activeStatus, setActiveStatus] = useState("")
    const [tableData, setTableData] = useState("")
    const [untaggedPaymentTableData, setUntaggedPaymentTableData] = useState("")
    const [tableMandateData, setTableMandateData] = useState("")
    const [mandateData, setMandateData] = useState("");
    const [rejectMandateModal, setRejectMandateModal] = useState(false);
    const [paymentMandateModal, setPaymentMandateModal] = useState(false);
    const [acknowledgeMandateModal, setAcknowledgeMandateModal] = useState(false);
    const [completeMandateModal, setCompleteMandateModal] = useState(false);
    const [refundMandateModal, setRefundMandateModal] = useState(false);
    const [editManualPunch, setEditManualPunch] = useState(false);
    const [orderHistory, setOrderHistory] = useState("");

    const [editMandate, setEditMandate] = useState(false);
    const [queryData, setQueryData] = useState("");

    // function to get orders by type
    async function getOrdersByType(type, page, size, replace) {
        try {
            let response = await getOrderListByType(token, type, page, size === configs.allRecordsFetchedTillNow ? tableData.length + configs.startPage : size)
            if (response && response.status === 200) {
                replace ? setTableData(response.data) : setTableData([...tableData, ...response.data])
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            }
            else { return response.data.error }
        } catch (error) {

        }
    }

    // save utr detail by order id
    async function saveUTRByOrder(orderId, utrList) {
        try {
            let response = await saveUTRByOrderId(token, orderId, utrList);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // complete demat transfer
    async function completeDematTransferByOrderId(orderId, remark, moveBack) {
        try {
            let response = await completeDematTransferByOrder(token, orderId, remark, moveBack);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // update payment pending order status
    async function updatePayPendingStatusByOrderId(orderId, remark) {
        try {
            let response = await updatePayPendingStatusByOrder(token, orderId, remark);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // generate cashfree payment link by order id
    async function generateCashfreePaymentLinkByOrderId(orderId) {
        try {
            let response = await generateCashfreePaymentLink(token, orderId);
            if (response && response.status === 200) {
                return {
                    "success": "success",
                    "data": response.data
                }
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response?.data?.error || "Unable to generate payment link."
            }
        } catch (error) {

        }
    }

    // get order detail by order id
    async function getOrderDetailById(orderId) {
        try {
            let response = await getOrderDetail(token, orderId);
            if (response && response.status === 200) {
                return {
                    "success": "success",
                    "data": response.data
                }
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // acknowledge manual payment order
    async function acknowledgeManualPaymentByOrderId(orderId, remark, customerRemark, status, utrList, dateTime) {
        try {
            let response = await acknowledgeManualPaymentByOrder(token, orderId, remark, customerRemark, status, utrList, dateTime);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // reject high value order
    async function rejectHighValueOrderById(orderId, remark) {
        try {
            let response = await rejectHighValueOrder(token, orderId, remark);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // refund high value order
    async function refundHighValueOrderById(orderId, remark) {
        try {
            let response = await refundHighValueOrder(token, orderId, remark);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {
            console.error(error);

        }
    }

    // complete refund high value order
    async function completeRefundHighValueOrderById(orderId, remark) {
        try {
            let response = await completeRefundHighValueOrder(token, orderId, remark);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {
            console.error(error);

        }
    }


    // approve high value order
    async function approveHighValueOrderById(orderId, quantity, price, new_user_id, upmark, upmark_final_pay, update, distributorId, deal_done_by_admin_id) {
        try {
            let response = await approveHighValueOrder(token, orderId, quantity, price, update, new_user_id, upmark, upmark_final_pay, distributorId, deal_done_by_admin_id);
            if (response && response.status === 200) {
                setUpdate(false)
                return {
                    "success": "success",
                    "data": response.data
                }
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // delete order
    async function deleteOrderById(orderId) {
        try {
            let response = await deleteOrder(token, orderId);
            if (response && response.status === 200) {
                return {
                    "success": "success",
                    "data": response.data
                }
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // restore order
    async function restoreOrderById(orderId) {
        try {
            let response = await restoreOrder(token, orderId);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // get all companies
    async function getCompanyList() {
        try {
            let response = await getAllCompanies(token);
            if (response && response.status === 200) {
                return {
                    "success": "success",
                    data: response.data
                }
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // get all slbas by companies
    async function getCompanySlabsByCompanyId(companyId) {
        try {
            let response = await getCompanySlabs(token, companyId);
            if (response && response.status === 200) {
                return {
                    "success": "success",
                    "data": response.data
                }
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // get all slbas by companies
    async function manualOrderPunch(userId, companyId, price, quantity, distributorId, upmark, upmark_final_pay, allow_user_update, allow_regular_commission, allow_advance_dealer_delivery, deal_done_by_admin_id) {
        try {
            let response = await manualOrderPunchCustomerId(token, userId, companyId, price, quantity, distributorId, upmark, upmark_final_pay, allow_user_update, allow_regular_commission, allow_advance_dealer_delivery, deal_done_by_admin_id);
            if (response && response.status === 200) {
                return {
                    "success": "success",
                    "data": response.data
                }
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    // async function download invoice
    async function downloadInvoiceByOrderId(orderId) {
        try {
            let response = await downloadInvoice(token, orderId);
            if (response && response.status === 200) {
                let a = document.createElement("a"); //Create <a>
                a.href = response.data; //Image Base64 Goes here
                a.download = `Invoice_Order_${orderId}.pdf`; //File name Here
                a.click();
            } else if (response && response.status === 401) {
                logout();
                //setLoginError(configs.unauthorizedErrorMessage);
            }
            else { }
        } catch (error) {
            console.error(error)
        }
    }

    // async function download deal note
    async function downloadDealNoteByOrderId(orderId) {
        try {
            let response = await downloadDealNote(token, orderId);
            if (response && response.status === 200) {
                let a = document.createElement("a");
                a.href = response.data;
                a.download = `Deal_Note_${orderId}.pdf`;
                a.click();
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            }
        } catch (error) {
            console.error(error)
        }
    }

    // function to download SPD sheet
    async function downloadSPDSheetByOrderId(orderIds) {
        try {
            let response = await downloadSPDSheet(token, orderIds);
            if (response && response.status === 200) {
                let a = document.createElement("a"); //Create <a>
                a.href = response.data.file; //Image Base64 Goes here
                a.download = response.data.fileName; //File name Here
                a.click();
                return "success"
            } else if (response && response.status === 401) {
                logout();
                //setLoginError(configs.unauthorizedErrorMessage);
            }
            else {
                return response.data.error;
            }
        } catch (error) {
            console.error(error)
        }
    }

    // function to download HDFC sheet
    async function downloadHDFCSheetByOrderId(orderIds, mandate) {
        try {
            let response = await downloadHDFCSheet(token, orderIds, mandate);
            if (response && response.status === 200) {
                let a = document.createElement("a"); //Create <a>
                a.href = response.data.file; //Image Base64 Goes here
                a.download = response.data.fileName; //File name Here
                a.click();
                return "success"
            } else if (response && response.status === 401) {
                logout();
                //setLoginError(configs.unauthorizedErrorMessage);
            }
            else {
                return response.data.error;
            }
        } catch (error) {
            console.error(error)
        }
    }

    // async download social media image
    async function downloadSocialMediaImageByCompany(companyId, date, title, description) {
        try {

            let response = await downloadSocialMediaImage(token, companyId, date, title, description);
            if (response && response.status === 200) {
                let a = document.createElement("a"); //Create <a>
                a.href = response.data; //Image Base64 Goes here
                a.download = `${title}.pdf`; //File name Here
                a.click();

                return { success: "success" }
            } else if (response && response.status === 401) {
                logout();
                //setLoginError(configs.unauthorizedErrorMessage);
            }
            else {
                return response.data.error
            }
        } catch (error) {
            console.error(error)
        }
    }

    // get previous image data 
    async function getPrevSocialMediaImage() {
        try {

            let response = await getPrevSocialMediaImageData(token);
            if (response && response.status === 200) {
                return {
                    success: "success",
                    data: response.data
                }
            } else if (response && response.status === 401) {
                logout();
                //setLoginError(configs.unauthorizedErrorMessage);
            }
            else {
                return response.data.error
            }
        } catch (error) {
            console.error(error)
        }
    }

    // update buy order comment
    async function updateBuyOrderComment(orderId, comment) {
        try {
            let response = await buyOrderComment(token, orderId, comment);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }


    // get all mandate
    async function getAllMandate(type, page, size, replace) {
        try {
            let response = await getAllMandates(token, type, page, size === configs.allRecordsFetchedTillNow ? tableMandateData.length + configs.startPage : size)
            if (response && response.status === 200) {
                replace ? setTableMandateData(response.data) : setTableMandateData([...tableMandateData, ...response.data])
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }
    // get ccavenue history by order id
    async function getCCAvenueHistoryByOrderId(orderId) {
        try {
            let response = await getCCAvenueHistory(token, orderId)
            if (response && response.status === 200) {
                return {
                    success: true,
                    data: response.data
                }
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {
            console.error(error);
        }
    }

    // get all query form data
    async function getAllQueryData() {
        try {
            let response = await getQueryFormData(token)
            if (response && response.status === 200) {
                setQueryData(response.data);
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }


    // function to get untagged payments by type
    async function untaggedPaymentByType(status, classification, page, size, replace) {
        try {
            let response = await getUntaggedPaymentByType(token, status, classification, page, size === configs.allRecordsFetchedTillNow ? untaggedPaymentTableData.length + configs.startPage : size)
            if (response && response.status === 200) {
                replace ? setUntaggedPaymentTableData(response.data) : setUntaggedPaymentTableData([...untaggedPaymentTableData, ...response.data])
            } else if (response && response.status === 401) {
                logout();
                setLoginError(configs.unauthorizedErrorMessage);
            }
            else { return response.data.error }
        } catch (error) {

        }
    }


    return (
        <buyOrderContext.Provider
            value={{
                tableData,
                setTableData,
                untaggedPaymentTableData,
                setUntaggedPaymentTableData,
                orderId,
                setOrderId,
                getOrdersByType,
                utrDetailModal,
                setUtrDetailModal,
                saveUTRByOrder,
                activeStatus,
                setActiveStatus,
                dematTransferModal,
                setDematTransferModal,
                completeDematTransferByOrderId,
                payPendStatusModal,
                setpayPendStatusModal,
                updatePayPendingStatusByOrderId,
                generateCashfreePaymentLinkByOrderId,
                orderDetail,
                setOrderDetail,
                getOrderDetailById,
                manualPayAckModal,
                setManualPayAckModal,
                acknowledgeManualPaymentByOrderId,
                hpRejectModal,
                setHPRejectModal,
                rejectHighValueOrderById,
                refundHighValueOrderById,
                completeRefundHighValueOrderById,
                setUpdate,
                hpApproveModal,
                setHPApproveModal,
                approveHighValueOrderById,
                hpApproveQuantity,
                setHPApproveQuantity,
                hpApprovePrice,
                setHPApprovePrice,
                hpApproveInstrument,
                setHPApproveInstrument,
                getCompanyList,
                getCompanySlabsByCompanyId,
                manualOrderPunch,
                deleteOrderById,
                restoreOrderById,
                downloadInvoiceByOrderId,
                downloadDealNoteByOrderId,
                downloadSPDSheetByOrderId,
                downloadSocialMediaImageByCompany,
                commentModal,
                setCommentModal,
                updateBuyOrderComment,
                utrBreakupModal,
                setUtrBreakupModal,
                getAllMandate,
                mandateData,
                setMandateData,
                tableMandateData,
                setTableMandateData,
                hpRefundModal,
                setHPRefundModal,
                hpCompleteRefundModal,
                setHPCompleteRefundModal,
                downloadHDFCSheetByOrderId,
                getCCAvenueHistoryByOrderId,
                queryData,
                setQueryData,
                getAllQueryData,
                rejectMandateModal,
                setRejectMandateModal,
                paymentMandateModal,
                setPaymentMandateModal,
                acknowledgeMandateModal,
                setAcknowledgeMandateModal,
                completeMandateModal,
                setCompleteMandateModal,
                refundMandateModal,
                setRefundMandateModal,
                editMandate,
                setEditMandate,
                editManualPunch,
                setEditManualPunch,
                orderHistory,
                setOrderHistory,
                getPrevSocialMediaImage,
                untaggedPaymentByType
            }}
        >
            {children}
        </buyOrderContext.Provider>)

}

export function useBuyOrderContext() {
    return useContext(buyOrderContext)
}
